import type { AuthSessionState, CmmdUserIdentity } from "@cmmd-forge/contracts";

export interface PrimaryAccountIdentity {
  readonly displayName: string;
  readonly email: string | null;
  readonly avatarUrl: string | null;
  readonly role: "owner" | "client";
  readonly verified: boolean;
  readonly source: "cmmd-identity" | "fallback";
}

export function resolvePrimaryAccountIdentityFromSession(
  session: AuthSessionState,
): PrimaryAccountIdentity {
  if (!session.authenticated || !session.role) {
    throw new Error("Authenticated session is required.");
  }

  const displayName = resolveCmmdIdentityDisplayName(session.cmmdIdentity ?? null);
  if (displayName) {
    return {
      displayName,
      email: session.cmmdIdentity?.email ?? null,
      avatarUrl: session.cmmdIdentity?.avatarUrl ?? null,
      role: session.role,
      verified: true,
      source: "cmmd-identity",
    };
  }

  return {
    displayName: "CMMD identity unavailable",
    email: null,
    avatarUrl: null,
    role: session.role,
    verified: false,
    source: "fallback",
  };
}

function resolveCmmdIdentityDisplayName(identity: CmmdUserIdentity | null): string | null {
  if (!identity) return null;
  const fullName = [identity.firstName, identity.lastName]
    .map((part) => part?.trim() ?? "")
    .filter((part) => part.length > 0)
    .join(" ");
  if (fullName) return fullName;
  const username = identity.username.trim();
  if (username) return username;
  const email = identity.email.trim();
  return email || null;
}
